// src/components/Admin/Admin.js
import React, { useState, useEffect } from "react";
import { database } from "../../firebase";
import { ref as dbRef, push, onValue, remove } from "firebase/database";
import "./Admin.css";

export default function Admin() {
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState({
    name: "",
    
    description: "",
    price: "",
    imageURL: ""   // <-- store image URL instead of file
  });
  const [loading, setLoading] = useState(false);

  // Fetch existing products
  useEffect(() => {
    const productsRef = dbRef(database, "products");
    onValue(productsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.entries(data).map(([id, value]) => ({ id, ...value }));
        setProducts(list);
      } else {
        setProducts([]);
      }
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.description || !form.price || !form.imageURL) {
      alert("All fields are required!");
      return;
    }

    setLoading(true);
    try {
      await push(dbRef(database, "products"), {
        name: form.name,
        description: form.description,
        price: form.price,
        image: form.imageURL   // <-- save URL directly
      });
      setForm({ name: "", description: "", price: "", imageURL: "" });
      alert("Product added successfully!");
    } catch (error) {
      console.error("Error adding product:", error);
      alert("Failed to add product. Check console.");
    }
    setLoading(false);
  };

  const handleDelete = async (product) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      try {
        // No need to delete from Firebase Storage (since we only save URLs)
        await remove(dbRef(database, `products/${product.id}`));
      } catch (error) {
        console.error("Failed to delete product:", error);
      }
    }
  };

  return (
    <div className="admin-container">
      <h2>Admin Panel</h2>

      <form className="product-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Product Name"
          value={form.name}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="description"
          placeholder="Product Description"
          value={form.description}
          onChange={handleChange}
          required
        />
        <input
          type="number"
          name="price"
          placeholder="Price"
          value={form.price}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="imageURL"
          placeholder="Image URL"
          value={form.imageURL}
          onChange={handleChange}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Adding..." : "Add Product"}
        </button>
      </form>

      <h3>Existing Products</h3>
      <div className="product-grid-admin">
        {products.map((product) => (
          <div className="product-card-admin" key={product.id}>
            <img src={product.image || "/images/placeholder.png"} alt={product.name} />
            <h4>{product.name}</h4>
            <p>{product.description}</p>
            <div>₹{product.price}</div>
            <button className="delete-btn" onClick={() => handleDelete(product)}>Delete</button>
          </div>
        ))}
      </div>
    </div>
  );
}
